import React, {Component} from 'react'
import Cookies from 'js-cookie'
import querystring from 'querystring' // npm i querystring
import PropTypes from 'prop-types'
import config from '../config/index'
import {emailRegex} from '../utils/email'
import {relative} from 'path'
export default class extends Component {
  static propTypes = {
    buttonText: PropTypes.string,
    className: PropTypes.string,
    inputId: PropTypes.string,
    size: PropTypes.string,
  }

  static defaultProps = {
    buttonText: 'Get started →',
    className: '',
    inputId: undefined,
    size: 'md',
  }

  constructor(props) {
    super(props)
    this.state = {
      email: '',
      error: false,
    }
  }

  onChange = e => {
    this.setState({
      [e.currentTarget.name]: e.currentTarget.value,
    })
  }

  onSubmit = async e => {
    e.preventDefault()

    if (!this.state.email || !emailRegex.test(this.state.email)) {
      this.setState({
        error: true,
      })
      return
    }

    try {
      const body = querystring.stringify({
        email: this.state.email,
        isdisclosuresuser: true,
        lp_val_prop: 'A listing tool kit for real estate professionals',
        hompagecta: 'get started',
        hs_context: JSON.stringify({
          hutk: Cookies.get('hubspotutk'),
          pageUrl: document.referrer,
          pageName: document.title,
        }),
      })

      await fetch(`https://forms.hubspot.com/uploads/form/v2/${config.hubspot.signupPortal}/${config.hubspot.signupForm}`, {
        method: 'POST',
        body: body,
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Content-Length': body.length,
        },
      })
    } catch (error) {
      console.error(error)
    }

    window.location = `${config.appUrl}/auth/signup?return_uri_email=${this.state.email}`
  }

  render() {
    return (
      <div className="signup-form-mob-wrap th-home--mobiletop">
        <div className="signup-form-mob-container container grid-md pt-2 text-center" style={{marginBottom: '.5rem', marginTop: '0rem'}}>
          <div className="signup-form-mob-columns columns">
            <div className="signup-form-mob-column column container grid-md">
              <form
                className={`signup-form-mob input-group ${this.props.className} ${this.state.error ? 'has-error' : ''}`}
                method="GET"
                onSubmit={this.onSubmit}>
                <input
                  id={this.props.inputId}
                  type="email"
                  name="email"
                  className={`form-input ${this.props.size === 'sm' ? 'input-sm' : ''}`}
                  placeholder="you@brokerage.com"
                  value={this.state.email}
                  onChange={this.onChange}
                  style={{borderRadius: '3px'}}
                />

                <button
                  className={`btn btn-primary ${this.props.size === 'sm' ? 'btn-sm' : ''} input-group-btn`}
                  style={{borderRadius: '3px', fontSize: '16px', textTransform: 'none', fontWeight: '800'}}>
                  {this.props.buttonText}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
